import {Injectable} from "@angular/core";
import {Observable, Subject, throwError} from "rxjs";

const MAX_FILE_SIZE = 104_857_600;

class FileReadError extends Error {
  constructor(message: string) {
    super(message);
  }
}

const fileReadErrorMessages = {
  cannotReadFile: "Cannot read file.",
  fileSizeExceed: "File size is more then 100Mb.",
};

@Injectable()
export class FileOperationsService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private _fileRead$: Subject<any> = null;

  initialize(): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this._fileRead$ = new Subject<any>();
  }

  destroy(): void {
    this._fileRead$.complete();
    this._fileRead$ = null;
  }

  readFile(file: File): Observable<string> {
    if (!this.isFileSizeAllowed(file)) {
      throwError(() => new FileReadError(fileReadErrorMessages.fileSizeExceed));
    }

    file = new File([file], `${file.name}.txt`, {
      type: "text/plain",
      lastModified: file.lastModified,
    });

    const reader: FileReader = new FileReader();
    reader.onload = this.processFile;
    reader.readAsText(file);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reader.onerror = (event: any) => {
      console.error(event);
      throwError(() => new FileReadError(fileReadErrorMessages.cannotReadFile));
    };

    return this._fileRead$.asObservable();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private processFile = (event: any): void => {
    const data: string = event.target.result;

    if (data?.trim()?.length) {
      this._fileRead$.next(data);
    } else {
      throwError(() => fileReadErrorMessages.cannotReadFile);
    }
  };

  private isFileSizeAllowed(file: File): boolean {
    return file.size <= MAX_FILE_SIZE;
  }
}
